module.exports = __webpack_public_path__ + "img/UpChat.9669854d.svg";